{
  "name": "fxhp-web",
  "version": "4.18.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build-dev": "ng build --configuration=dev --output-hashing=all && node inject-csp.js",
    "build-test": "ng build --configuration=test --output-hashing=all && node inject-csp.js",
    "build-demo": "ng build --configuration=demo --output-hashing=all && node inject-csp.js",
    "build-staging": "ng build --configuration=staging --output-hashing=all && node inject-csp.js",
    "build-automation": "ng build --configuration=automation --output-hashing=all && node inject-csp.js",
    "build-live": "ng build --configuration=live --output-hashing=all && node inject-csp.js",
    "build-dr": "ng build --configuration=dr --output-hashing=all && node inject-csp.js",
    "typescript-check-strict": "tsc-strict --project tsconfig.root.json",
    "test": "jest",
    "test:ci": "jest --config=jest.config.ci.ts",
    "lint": "ng lint && npm run lint-html-plugin",
    "lint-html-plugin": "eslint -c ./.eslintrc-html-parser.json --no-eslintrc src/app/**/*.html",
    "stats": "ng build --configuration=live --source-map=false --output-hashing=all --stats-json && webpack-bundle-analyzer dist/fxhp-web/stats.json",
    "cy:run": "cypress run --browser chrome --headless",
    "cypress-dashboard": "CYPRESS_BASE_URL=http://localhost:4200 CYPRESS_environment=Test ng e2e --c test",
    "cypress-headless": "CYPRESS_BASE_URL=http://localhost:4200 CYPRESS_environment=Test ng e2e --c automation",
    "cypress-run-regression-test": "CYPRESS_BASE_URL=https://portal.exchange-test.lmax.com CYPRESS_environment=Test TZ=America/New_York ./node_modules/.bin/cypress run --browser chrome --headless --record --parallel --key acd99a29-2c68-47d9-b79e-303bb3f31c92 --spec 'cypress/e2e/**/*.spec.ts'",
    "mongodump-create-test-env-snapshot": "mkdir -p mongo-snapshots && mongodump --uri=\"$MONGO_URI_TEST\" --archive=./mongo-snapshots/test-env-snapshot.gz --db fxhp --gzip",
    "mongorestore-test-env-snapshot": "mongorestore --uri=\"$MONGO_URI_TEST\" --archive=./mongo-snapshots/test-env-snapshot.gz --gzip --drop",
    "aws-codebuild-mongorestore-test-env-snapshot": "mongorestore --quiet --uri=\"mongodb+srv://${MONGO_USER}:${MONGO_PASS}@${MONGO_HOST}\" --archive=./mongo-snapshots/test-env-snapshot.gz --gzip --drop"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/fire": "^18.0.1",
    "@angular/forms": "^18.2.13",
    "@angular/material": "^18.2.14",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@sentry/angular": "^9.13.0",
    "@stomp/rx-stomp": "^2.3.0",
    "@types/file-saver": "^2.0.7",
    "ag-grid-angular": "^35.0.0",
    "ag-grid-community": "^35.0.0",
    "ag-grid-enterprise": "^35.0.0",
    "core-js": "^2.6.12",
    "date-fns": "^2.14.0",
    "date-fns-tz": "^2.0.0",
    "file-saver": "^2.0.5",
    "jwt-decode": "^4.0.0",
    "lodash-es": "^4.17.23",
    "ngx-mask": "^13.2.1",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.19",
    "@angular-eslint/builder": "^18.4.3",
    "@angular-eslint/eslint-plugin": "^18.4.3",
    "@angular-eslint/eslint-plugin-template": "^18.4.3",
    "@angular-eslint/schematics": "^18.4.3",
    "@angular-eslint/template-parser": "^18.4.3",
    "@angular/cli": "^18.2.19",
    "@angular/compiler-cli": "^18.2.13",
    "@angular/language-service": "^18.2.13",
    "@cypress/schematic": "^4.3.0",
    "@html-eslint/eslint-plugin": "^0.39.0",
    "@html-eslint/parser": "^0.39.0",
    "@sentry/cli": "^2.45.0",
    "@testing-library/angular": "^14.5.1",
    "@testing-library/dom": "^10.4.0",
    "@testing-library/jest-dom": "^6.6.3",
    "@testing-library/user-event": "^14.6.1",
    "@types/jest": "^29.5.14",
    "@types/jsonwebtoken": "^9.0.10",
    "@types/lodash-es": "^4.17.12",
    "@typescript-eslint/eslint-plugin": "^8.32.0",
    "@typescript-eslint/eslint-plugin-tslint": "^7.0.2",
    "@typescript-eslint/parser": "^8.32.0",
    "cypress": "^15.9.0",
    "cypress-parallel": "^0.15.0",
    "cypress-real-events": "^1.14.0",
    "date-holidays": "^3.25.1",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^10.1.2",
    "eslint-plugin-cypress": "^3.6.0",
    "eslint-plugin-fxhp": "file:./eslint-plugin-fxhp",
    "eslint-plugin-import": "2.25.2",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.2.6",
    "eslint-plugin-sonarjs": "^3.0.2",
    "jest": "^29.7.0",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "^14.5.4",
    "jsonwebtoken": "^9.0.3",
    "mocha-junit-reporter": "^2.2.1",
    "ng-packagr": "^18.2.1",
    "prettier": "^3.7.4",
    "prettier-eslint": "^16.4.1",
    "ts-node": "^10.9.2",
    "typescript": "~5.4.5",
    "typescript-eslint": "^8.0.0",
    "typescript-strict-plugin": "^2.4.4",
    "wait-on": "^8.0.3",
    "xlsx": "^0.18.5"
  }
}
